<template>
  <v-container fluid fill-height class="d-flex justify-center">
    <v-app-bar app elevation="0" color="indigo lighten-5">
      <img
        src="@/assets/logo.svg"
        style="height:40px"
        class="hidden-md-and-up"
      />
      <v-spacer></v-spacer>
      <language-switcher class="mr-2"></language-switcher>
      <v-btn
        rounded
        elevation="0"
        outlined
        color="secondary"
        dark
        @click="inicio"
        >{{ $t('home') }}</v-btn
      >
    </v-app-bar>

    <div style="width:500px" class="text-center hidden-sm-and-down">
      <img src="@/assets/logo.svg" style="height:50px" />
      <div
        class="text-sm-h6 text-md-h5 text-lg-h5 text-xl-h5 text-h6 font-weight-thin my-5"
        v-html="$t('slogan_html')"
      ></div>
      <img src="../assets/cover.svg" style="max-height:240px" />
    </div>

    <v-divider class="mx-5 hidden-sm-and-down" vertical></v-divider>

    <router-view
      v-bind:class="{ 'auth-route-width': !$vuetify.breakpoint.xs }"
    ></router-view>
  </v-container>
</template>

<script>
import LanguageSwitcher from '@/components/LanguageSwitcher';

export default {
  components: { LanguageSwitcher },
  methods: {
    inicio() {
      this.$router.push({ path: '/home' });
    }
  }
};
</script>

<style>
.auth-route-width {
  width: 378px;
}
</style>
